<template>
  <div class="Tetapkanpenyeliaprosesanoperasi">
    <v-card outlined class="mb-4">
      <v-card-title class="py-3 kad__tajuk d-flex align-center flex-wrap">
        <v-icon small class="mr-2">mdi-account-cog</v-icon>
        <span class="subtitle-1 font-weight-medium">{{ $t("tetapkanpppo") }}</span>
      </v-card-title>
      <v-card-text class="pt-6">
        <Pppoinput></Pppoinput>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Pppoinput from "@/components/Pppoinput/pppoinput";
export default {
  name: "Tetapkanpenyeliaprosesanoperasi",
  components: {
    Pppoinput,
  },
  setup() {},
  mounted() {},
  data: () => ({}),
  methods: {},
};
</script>